<template>
  <Modal :value="value" v-on="$listeners">
    <p class="pb-2 text-2xl font-bold leading-tight">
      {{ $t('popups.removeVoucher.title', { code: voucher.code }) }}
    </p>

    <div
      v-for="(error, index) in errors"
      :key="index"
      class="flex w-full p-4 mt-2 mb-6 border border-sn-secondary-700 bg-sn-secondary-100"
    >
      <div class="flex-shrink-0 pt-px mr-2">
        <svg viewBox="0 0 195 195" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-4 fill-current text-sn-secondary-700'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M97.5 195c53.8 0 97.5-43.7 97.5-97.5S151.3 0 97.5 0 0 43.7 0 97.5 43.7 195 97.5 195zM44.4 65.6l21.2-21.2 31.9 31.9 31.9-31.9 21.2 21.2-31.9 31.9 31.9 31.9-21.2 21.2-31.9-31.9-31.9 31.9-21.2-21.2 31.9-31.9z"/></svg>
      </div>
      <div>
        <p class="pb-2 font-bold leading-none xl:text-lg">
          {{ $t(`errors.type.${error}.title`, brandInfo) }}
        </p>
        <p class="text-xs xl:text-sm" v-html="$t(`errors.type.${error}.description`, brandInfo)" />
      </div>
    </div>

    <div class="flex flex-col-reverse pt-5 xl:flex-row xl:pt-8">
      <div class="mt-4 xl:mt-0 xl:mr-4">
        <Button
          :loading="loading"
          type="button"
          @click="deleteVoucher"
        >
          {{ $t('popups.removeVoucher.button.submit') }}
        </Button>
      </div>
      <div>
        <Button
          :disabled="loading"
          variant="secondary"
          type="button"
          @click.prevent="$emit('input', false)"
        >
          {{ $t('popups.removeVoucher.button.close') }}
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import Modal from '~brand-components/brussels/modal/modal.vue'
import RemoveVoucherPopup from '~app/psp/base/remove-voucher-popup.ts'
import Button from '~brand-components/brussels/button/button.vue'

export default RemoveVoucherPopup.extend({
  components: {
    Modal,
    Button,
  },
})
</script>
